"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("../../utils/common");
var _log = _interopRequireDefault(require("../../utils/log"));
var _autoPvLister = _interopRequireDefault(require("./auto-pv-lister"));
var _clickEventLister = _interopRequireDefault(require("./click-event-lister"));
var visitOrderTracking = function visitOrderTracking(params, legoInit) {
  if (!params || !params.routeList) return;
  // 存储pageId信息
  (0, _common.setPageIdObj)(params.routeList);

  // 初始化点击事件监听
  _log.default.info('已开启点击zpmclick事件插件');
  (0, _clickEventLister.default)();
  var pageIdInfo = (0, _common.getPageIdInfo)(); // 当前路由命中了 routeList
  if (!pageIdInfo || !pageIdInfo.pageId) return;
  if (pageIdInfo.isAutoPV === false) {
    // 存储恢复的函数
    legoInit.resumePV = function () {
      _log.default.info('已开启页面zpmshow事件插件');
      (0, _autoPvLister.default)(params, legoInit);
    };
    return;
  }
  _log.default.info('已开启页面zpmshow事件插件');
  (0, _autoPvLister.default)(params, legoInit);
};
var _default = visitOrderTracking;
exports.default = _default;